const types = {
  about_us: 'About Us',
  property: 'Property',
  area: 'Area',
  activity: 'Activity',
  misc: 'Miscellaneous',
  about_safari: 'Introductory Notes',
  pre_travel_info: 'Pre Travel Information',
  help_tutorial: 'Help Tutorial',
  help_article: 'Help Article',
  unknown: 'Unknown Type',
};

export default types;
